import { render, staticRenderFns } from "./ChildCalendarNotification.vue?vue&type=template&id=2399fd66&scoped=true"
import script from "./ChildCalendarNotification.vue?vue&type=script&lang=js"
export * from "./ChildCalendarNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2399fd66",
  null
  
)

export default component.exports